import styled from 'styled-components'
import { H1, GridContainer, ContainerHeading, GridSection, Row, Column, ActionLink } from '../../styles/styled-elements'
import styledTheme from '../../styles/theme'

//export { H1, GridContainer, ContainerHeading, GridSection, Row, Column, ActionLink, styledTheme }

export const GaugeSetContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0px;
  width: 100%;
  border: none;
  margin-bottom: 20px;
  flex-wrap: wrap;
  @media (max-width: 1000px) {
    justify-content: center;
  }
`
export const GaugeContainer = styled.div`
  display: inline-flex;
  background-color: white;
  border: 1px solid black;
  padding: 10px;
  flex-direction: column;
  margin-right: 10px;
  margin-bottom: 10px;
  @media (max-width: 700px) {
    &:last-child {
      margin-right: 0px;
    }
  }
  @media (max-width: 550px) {
    margin-left: 0px;
    margin-right: 0px;
  }
`
export const GaugeHeading = styled.div`
  display: block;
  width: 300px;
  padding: 6px;
  font-weight: 700;
`
export const DataViewContainer = styled.div`
  display: flex;
  background-color: white;
  flex-direction: column;
  padding: 10px;
  width: 100%;
  border: 1px solid black;
  margin-bottom: 20px;
`
export const DataViewHeadingDiv = styled.div`
  display: block;
  width: 100%;
  padding: 6px;
`
export const DataViewHeadingText = styled.span`
  font-weight: 700;
  margin-right: 10px;
`
export const DataViewHeadingLinks = styled.span`
  vertical-align: 3px;
`
export const DataViewBody = styled.div`
  display: block;
  padding: 6px;
`
export const DashboardGraphHeadingExpandLinkCell = styled.div`
  display: inline-flex;
  padding-right: 10px;
  align-items: flex-end;
`
export const DashboardGraphHeadingExpandLink = styled.span`
  padding: 2px 4px;
  border-radius: 3px;
  background-color: ${styledTheme.colors.button_background};
  color: #FFF;
  text-decoration: none;
  cursor: pointer;
  font-size: 0.6rem;
`




// WEBPACK FOOTER //
// ./src/containers/dashboard/styled-elements.js